import { render } from "./SwSearchField.vue?vue&type=template&id=8c6a8fec"
import script from "./SwSearchField.vue?vue&type=script&lang=js"
export * from "./SwSearchField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__